// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_iconeAdd__QvVQo {
    color: #fff;
    font-size: 2rem;
  }
  
  .styles_iconeAdd__QvVQo:hover {
    color: #18316e;
  }
  
  .styles_containerButtons__4x2pH {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }

  .styles_btn__filterDate__n9u2c {
    all: unset;
    cursor: pointer;
    color: #fff;
    background-color: #18316e;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.5s ease-in-out;
    gap: 5px;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.21);
  }   
  
  .styles_actions__bar__mloH3,
  .styles_filterData__bar__X4-dT,
  .styles_extrator__bar__AYGI0 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .styles_actions__bar__mloH3 {
    width: 100%;
    justify-content: space-between;
  }
  
  .styles_filterData__bar__X4-dT {
    display: flex;
    align-items: center;
    padding: 6px;
    border-radius: 7px;
    padding: 9px;
    background-color: #fff;
    gap: 15px;
  }

  .styles_filterData__bar__X4-dT .styles_MuiTextField-root__fUAM\\+ {
    flex: 1 1;
    margin-top: 0 !important;
  }

  .styles_MuiInputAdornment-root__8FBj2 {
    font-weight: bold;
    color: #18316e;
  }

  .styles_MuiTextField-root__fUAM\\+ {
    width: 100%;
  }

  .styles_botaoNovo__jdWPW {
    width: 100% !important;
    background-color: #0f2047 !important;
    color: #ffffff !important;
    border-color: #ffffff !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    text-transform: capitalize !important;
    height: 36px !important;
  }
  
  .styles_botaoNovo__jdWPW:hover {
    transform: scale(0.95) !important;
  }

  .styles_btnComplementary__jUjXI{
    border-radius: 50px !important;
    border-color: #18316e !important;
    color: #18316e !important;
    &:hover {
      border-color: #18316e !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/StepsAnalisar/Relatorio20s/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,QAAQ;IACR,2CAA2C;EAC7C;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;IAC7B,6BAA6B;IAC7B,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB;MACE,gCAAgC;IAClC;EACF","sourcesContent":[".iconeAdd {\n    color: #fff;\n    font-size: 2rem;\n  }\n  \n  .iconeAdd:hover {\n    color: #18316e;\n  }\n  \n  .containerButtons {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n  }\n\n  .btn__filterDate {\n    all: unset;\n    cursor: pointer;\n    color: #fff;\n    background-color: #18316e;\n    padding: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    transition: all 0.5s ease-in-out;\n    gap: 5px;\n    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.21);\n  }   \n  \n  .actions__bar,\n  .filterData__bar,\n  .extrator__bar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .actions__bar {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .filterData__bar {\n    display: flex;\n    align-items: center;\n    padding: 6px;\n    border-radius: 7px;\n    padding: 9px;\n    background-color: #fff;\n    gap: 15px;\n  }\n\n  .filterData__bar .MuiTextField-root {\n    flex: 1;\n    margin-top: 0 !important;\n  }\n\n  .MuiInputAdornment-root {\n    font-weight: bold;\n    color: #18316e;\n  }\n\n  .MuiTextField-root {\n    width: 100%;\n  }\n\n  .botaoNovo {\n    width: 100% !important;\n    background-color: #0f2047 !important;\n    color: #ffffff !important;\n    border-color: #ffffff !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    text-transform: capitalize !important;\n    height: 36px !important;\n  }\n  \n  .botaoNovo:hover {\n    transform: scale(0.95) !important;\n  }\n\n  .btnComplementary{\n    border-radius: 50px !important;\n    border-color: #18316e !important;\n    color: #18316e !important;\n    &:hover {\n      border-color: #18316e !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconeAdd": `styles_iconeAdd__QvVQo`,
	"containerButtons": `styles_containerButtons__4x2pH`,
	"btn__filterDate": `styles_btn__filterDate__n9u2c`,
	"actions__bar": `styles_actions__bar__mloH3`,
	"filterData__bar": `styles_filterData__bar__X4-dT`,
	"extrator__bar": `styles_extrator__bar__AYGI0`,
	"MuiTextField-root": `styles_MuiTextField-root__fUAM+`,
	"MuiInputAdornment-root": `styles_MuiInputAdornment-root__8FBj2`,
	"botaoNovo": `styles_botaoNovo__jdWPW`,
	"btnComplementary": `styles_btnComplementary__jUjXI`
};
export default ___CSS_LOADER_EXPORT___;
